import {downloadGeneratedImageAsset} from '@Components/ai-chat-window/lib/ai-chat-downloads.library';
import {FileTypeOptions} from '@Components/download-panel/components/file-type-option/file-type-option.types';
import {ImageQualityOption} from '@Components/download-panel/components/ai-chat-image-download-panel-content/ai-chat-image-download-panel-content.types';
import type {ButtonAction} from './button-group.types';

export const dispatchButtonAction = async (action: ButtonAction): Promise<void> => {
  switch (action.type) {
    case 'download': {
      const fileType = action.fileType === 'pdf' ? FileTypeOptions.PDF : FileTypeOptions.PNG;
      const quality = action.imageQuality === 'enhanced_4k' ? ImageQualityOption.ENHANCED_4K : ImageQualityOption.ORIGINAL;
      await downloadGeneratedImageAsset(action.chatId, action.hashedId, quality, fileType);
      return;
    }
  }
};
